webpackJsonp([1],{

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSessions = fetchSessions;
exports.fetchSessionsSuccess = fetchSessionsSuccess;
exports.fetchSessionsError = fetchSessionsError;
var FETCH_SESSIONS = exports.FETCH_SESSIONS = 'FETCH_SESSIONS';
var FETCH_SESSIONS_SUCCESS = exports.FETCH_SESSIONS_SUCCESS = 'FETCH_SESSIONS_SUCCESS';
var FETCH_SESSIONS_ERROR = exports.FETCH_SESSIONS_ERROR = 'FETCH_SESSIONS_ERROR';

function fetchSessions(state) {
  state.loading = true;
  state.error = '';
  state.sessions = [];
}

function fetchSessionsSuccess(state, sessions) {
  state.error = '';
  state.loading = false;
  state.sessions = sessions;
}

function fetchSessionsError(state, error) {
  state.loading = false;
  state.error = error.toString();
}

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(12);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(89);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Sessions = __webpack_require__(86);

var _Sessions2 = _interopRequireDefault(_Sessions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: '/',
    name: 'Sessions',
    component: _Sessions2.default
  }]
});

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(85)

var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(88),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = __webpack_require__(45);

exports.default = {
  name: 'app',
  store: _store.store
};

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(48);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(37);

var Vuex = _interopRequireWildcard(_vuex);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'sessions',
  methods: (0, _extends3.default)({}, Vuex.mapActions(['retrieveSessions']), {
    openSessionDetail: function openSessionDetail(sessionId) {
      return alert('Session ' + sessionId.toString() + ' clicked');
    }
  }),
  computed: (0, _extends3.default)({}, Vuex.mapGetters(['loading', 'sessions', 'error'])),
  created: function created() {
    this.retrieveSessions();
  }
};

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(12);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(39);

var _App2 = _interopRequireDefault(_App);

var _index = __webpack_require__(38);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

new _vue2.default({
  el: '#app',
  router: _index2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(47);

var _promise2 = _interopRequireDefault(_promise);

exports.default = buildSessionsApi;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fakeSessions = [{
  id: 1,
  title: 'User story mapping',
  description: 'Bring your post-its',
  facilitator: 'Mike Smith',
  place: 'Parrot room',
  datetime: 'Today at 6 PM'
}, {
  id: 2,
  title: 'BDD',
  description: 'Beer Driven Development',
  facilitator: 'Jessica Oliver',
  place: 'Bar',
  datetime: 'Tomorrow at 12 AM'
}];

function retrieveSessions() {
  return new _promise2.default(function (resolve, reject) {
    setTimeout(function () {
      var probability = Math.random();
      if (probability < 0.6) resolve(fakeSessions);else reject('Connection problem');
    }, 1000);
  });
}

function buildSessionsApi() {
  return { retrieveSessions: retrieveSessions };
}

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveSessionsAction = retrieveSessionsAction;
exports.buildRetrieveSessionsAction = buildRetrieveSessionsAction;

var _sessionsApiService = __webpack_require__(43);

var _sessionsApiService2 = _interopRequireDefault(_sessionsApiService);

var _mutations = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function retrieveSessionsAction(sessionsApi) {
  function run(_ref) {
    var commit = _ref.commit;

    commit(_mutations.FETCH_SESSIONS);

    sessionsApi.retrieveSessions().then(function (sessions) {
      commit(_mutations.FETCH_SESSIONS_SUCCESS, sessions);
    }, function (error) {
      commit(_mutations.FETCH_SESSIONS_ERROR, error);
    });
  }
  return { run: run };
}

function buildRetrieveSessionsAction() {
  return retrieveSessionsAction((0, _sessionsApiService2.default)()).run;
}

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = undefined;

var _vue = __webpack_require__(12);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(37);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(44);

var _mutations = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.debug = true;
_vue2.default.use(_vuex2.default);

var initialState = {
  sessions: [],
  loading: false,
  error: ''
};

var store = exports.store = new _vuex2.default.Store({
  state: initialState,
  mutations: {
    FETCH_SESSIONS: _mutations.fetchSessions,
    FETCH_SESSIONS_SUCCESS: _mutations.fetchSessionsSuccess,
    FETCH_SESSIONS_ERROR: _mutations.fetchSessionsError
  },
  actions: {
    retrieveSessions: (0, _actions.buildRetrieveSessionsAction)()
  },
  getters: {
    sessions: function sessions(state) {
      return state.sessions;
    },
    loading: function loading(state) {
      return state.loading;
    },
    error: function error(state) {
      return state.error;
    }
  }
});

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(84)

var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(87),
  /* scopeId */
  "data-v-4cd51a88",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 87:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-panel__scroll",
    attrs: {
      "id": "session-list-panel"
    }
  }, [(_vm.loading) ? _c('h2', {
    staticClass: "title error"
  }, [_vm._v("LOADING...")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('h2', {
    staticClass: "error"
  }, [_vm._v("SERVER FAKE ERROR: " + _vm._s(_vm.error) + " (Refresh until you get the sessions)")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "session-list"
  }, _vm._l((_vm.sessions), function(session, index) {
    return _c('div', {
      staticClass: "session-list__item"
    }, [_c('div', {
      staticClass: "list-col--title"
    }, [_c('p', [_c('a', {
      on: {
        "click": function($event) {
          _vm.openSessionDetail(session.id)
        }
      }
    }, [_vm._v(_vm._s(session.title))])]), _vm._v(" "), _c('p', {
      staticClass: "related"
    }, [_vm._v(_vm._s(session.description))])]), _vm._v(" "), _c('div', {
      staticClass: "list-col--last-updated-on"
    }, [_c('p', [_c('span', {
      staticClass: "date",
      attrs: {
        "title": session.datetime
      }
    }, [_vm._v(_vm._s(session.datetime))])])]), _vm._v(" "), _c('div', {
      staticClass: "list-col--person"
    }, [_vm._v("\n          " + _vm._s(session.facilitator) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "list-col--place"
    }, [_vm._v("\n          " + _vm._s(session.place) + "\n        ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "content-panel__footer"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-panel__header"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h3', [_vm._v("SESSIONS")])])])
}]}

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ })

},[42]);


// WEBPACK FOOTER //
// static/js/app.aa7b45c1676e20c67557.js